const COLORS = {
    LOADING_COMPONENT: "linear-gradient(#87ccde 0%, rgb(75 189 162 / 80%) 100%)",
};

export default COLORS;
